import { cn } from "@newxsystems/shared";
import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightMedia } from "../../../../modules/content/components/DaylightMedia/DaylightMedia";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import type { ITextMediaBlockProps } from "./TextMediaBlock.props";

export const TextMediaBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  direction,
  eyebrow,
  heading,
  headingEffect,
  image,
  parentClass,
  spacing,
  video,
}: ITextMediaBlockProps) => {
  const videoDestination =
    video?.source === "direct"
      ? video.directVideo
      : video?.source === "youtube"
        ? video.youtubeVideo
        : video?.vimeoVideo;
  const hasCopy = Boolean(eyebrow || heading || description || buttons?.length);
  if (!image && !videoDestination) return null;
  const media = (
    <div className="flex min-w-0 flex-col gap-5">
      {image ? (
        <DaylightMedia
          aspectRatio={image.aspectRatio || "16:9"}
          media={image.image}
          effect={image.effect}
          sizes="(min-width: 768px) 50vw, 100vw"
        />
      ) : null}
      {video && videoDestination ? (
        <VideoPlayer
          banner={video.banner}
          directVideo={video.directVideo}
          source={video.source}
          vimeoVideo={video.vimeoVideo}
          youtubeVideo={video.youtubeVideo}
        />
      ) : null}
    </div>
  );
  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      {hasCopy ? (
        <div className="daylight-work-surface grid items-center gap-8 rounded-[28px] p-5 md:grid-cols-2 md:gap-12 md:p-8 lg:gap-16 lg:p-12">
          <div
            className={cn(
              "order-1 flex min-w-0 items-center px-2 py-6 md:px-4",
              direction === "ltr" && "md:order-2",
            )}
          >
            <DaylightCommonContent
              alignment={alignment}
              buttons={buttons}
              description={description}
              eyebrow={eyebrow}
              heading={heading}
              headingEffect={headingEffect}
              layout="stack"
              reveal
            />
          </div>
          <div
            className={cn("order-2 min-w-0", direction === "ltr" && "md:order-1")}
            data-reveal="stagger"
            data-reveal-enter="focus"
          >
            {media}
          </div>
        </div>
      ) : (
        media
      )}
    </DaylightSection>
  );
};

TextMediaBlock.displayName = "Block::TextMediaBlock";
